const state = {
}

const getters = {
}

const mutations = {
}

const actions = {
  updateCid ({ state, commit, rootState }, params) {
    return rootState.axios.post('/tpsp/v1frontend/tptt-item/update-cid', params)
  },
  updateCidRelcid ({ state, commit, rootState }, params) {
    return rootState.axios.post('/tpsp/v1frontend/tptt-item/update-cid-relcid', params)
  },
  searchTaobao ({ state, commit, rootState }, params) {
    return rootState.axios.get('/tpsp/v1frontend/tptt-item/search-taobao', { params }).then(res => {
      res.data.list.forEach(item => {
        if (!item.imageUrls && item.pic_url) {
          item.imageUrls = [item.pic_url]
        }
        if (item.title) {
          item.title = item.title.replaceAll(/<span[^>]+>|<\/span>/g, '')
        }
      })
      return res
    })
  },
  viewTaobao ({ state, commit, rootState }, params) {
    params = params.params ? params : { params }
    return rootState.axios.post('/tpsp/v1frontend/tptt-item/view-taobao', params.params, params.options)
  },
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
